/**
 * Subscribe observers and listen the messages from the Observable.
 * @class
 * */
 class Observable {
    /**
     * @constructor
     * */
    constructor() {
        /**  Saves the obsevers function according to a category.
            @type {Array} 
            @private
            */
        this.observers = [];
    }
    /**
     * Register Observers.
     * @param {String} pCategory Message Category.
     * @param {Function} pFunc Action to execute.
     */
    subscribe(pCategory, pFunc) {
        this.observers.push({
            Category: pCategory,
            Func: pFunc
        });
    }
    /**
     * Unregister Observers.
     * @param {String} pCategory Message Category.
     * @param {Function} pFunc Action to execute.
     */
    unsubscribe(pCategory, pFunc) {
        this.observers = this.observers.filter(obs => !(obs.Category === pCategory && Func === pFunc));
    }
    /**
     * Unregister all Observers from a specific Category.
     * @param {String} pCategory Message Category.
     */
    unsubscribeAll(pCategory) {
        this.observers = this.observers.filter(obs => obs.Category !== pCategory);
    }
    /**
     * Raise events from a specific Category.
     * @param {String} pCategory Message Category..
     * @param {any} pArg Function arguments.
     */
    notify(pCategory, pArg) {
        this.observers.forEach(obs => {
            if (obs.Category == pCategory) {
                obs.Func(pArg);
            }
        });
    }
}